import { useMutation } from "react-query";

import { getPlaysList } from "api/filter";

export default function useGetPlaysList(
  handlePostData: (postData: string[]) => void = null,
  handleError: (err) => void = null
) {
  const { isLoading, isError, error, mutate, data } = useMutation<string[]>(
    "getPlaysList",
    async () => {
      const result = await getPlaysList();
      return result as string[];
    },
    {
      onSuccess: (postData) => {
        handlePostData && handlePostData(postData);
      },
      onError: (err) => {
        if (handleError) {
          handleError(err);
        } else {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    }
  );

  return { isLoading, isError, error, mutate, data };
}
